export default class WeaveUi {
    constructor() {
        this.random = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    }

    randomString(length) {
        let result = '';
        for (var i = length; i > 0; --i) result += this.random[Math.floor(Math.random() * this.random.length)];
        return result;
    }
}


// WEBPACK FOOTER //
// ./js/weave-ui/weave-ui.js